import { render } from "./historical_inventory.vue?vue&type=template&id=3549a4c9"
import script from "./historical_inventory.vue?vue&type=script&lang=js"
export * from "./historical_inventory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__